import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import FaIcon from '@/components/ui/FaIcon.vue'
import BIcon from '@/components/ui/BIcon.vue'

// Self-hosted fonts (DSGVO-konform, keine Verbindung zu Google-Servern)
import '@fontsource/bebas-neue'
import '@fontsource/outfit/400.css'
import '@fontsource/outfit/500.css'
import '@fontsource/outfit/600.css'
import '@fontsource/outfit/700.css'

const app = createApp(App)

app.component('FaIcon', FaIcon)
app.component('BIcon', BIcon)

app.use(router)

app.mount('#app')
